import { BeforeMatchAnswer } from "@app/core/match/domain/model/before-match-question";
import { PlayerIdentificationData } from "@app/core/match/domain/model/player-identification-data";
import { Observable } from "rxjs";

/**
 * A repository for the player.
 */
export abstract class PlayerRepo {
  // Method to identify the player and submit their answers to the before-match questions
  abstract identifyPlayer(
    selected_code: number,
    match_code: string,
    answers: BeforeMatchAnswer[],
    token: string
  ): Observable<void>;
  // Method to get the player's photo to select after in the identification process
  abstract getPlayerIdentificationInformation(
    match_code: string,
    token: string
  ): Observable<PlayerIdentificationData>;
}
